<div class="modal-header">
    <div class="row col-12">        
        <div class="modal-title col-10">
            <h3>Standardfiltre</h3>
        </div>
        <div class="col-2 align-self-center">
            <div class="text-end">
                <button type="button" class="btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
                    <span aria-hidden="true" ><i class="fa-solid fa-x"></i></span>
                </button>    
            </div>
        </div>
    </div>
</div>


@if(isBusy)
{
    <div class="d-flex flex-column justify-content-center align-items-center w-100 vh-80">
        <div class="continuous-loader" role="status"></div>
        <h4 class="mt-2">{{busyText}}</h4>
    </div>
}
@else 
{

    <div class="modal-body col-12">
        <div class="row">   
            <div class="col-12">
                <label class="me-3 mt-2 fw-bold">Felt: </label>
                 <div class="input-group">
                    <select class="form-select col-3" id="dbtables-list"
                        (change)="onFieldChange($event)">
                        @for (items of dbTemplateInfo.dbTemplateItems; track $index) {
                            <option  [disabled]="items.id === ''" 
                                        [value]="items.id "> {{ items.name }}  ({{items.defaultValueTypeNonSql}}{{items.dbMaxLength != null && items.dbMaxLength > 0 ? '['+ items.dbMaxLength +']':''}}) </option>
                        }
                    </select>
                    <select class="form-select col-3"
                        (change)="onOperatorChange($event)">
                        <option value="=">Lig med</option>
                        <option value="!=">Ikke lig med</option>
                        <option value=">">Større end</option>
                        <option value="<">Mindre end</option>
                        <option value=">=">Større eller lig med</option>
                        <option value="<=">Mindre eller lig med</option>
                        <option value="LIKE">Indeholder</option>
                        <option value="NOT LIKE">Indeholder ikke</option>
                        <option value="IS NULL">Er tom</option>
                        <option value="IS NOT NULL">Er ikke tom</option>
                    </select>
                </div>
                <div class="input-group mt-2">
                    <input type="text" class="form-control col-4" placeholder="Værdi" aria-label="Værdi" aria-describedby="basic-addon2" [(ngModel)]="fieldValue">
                    <select class="form-select col-1"
                        (change)="onStatementOperatorChange($event)">
                        <option value="AND">Og</option>
                        <option value="OR">Eller</option>
                    </select>
                </div>
                <div class="input-group mt-2">
                    <button class="btn btn-primary me-2" (click)="addFilter('read')">Tilføj filter til læsning</button>
                    <button class="btn btn-primary" (click)="addFilter('delete')">Tilføj filter til sletning</button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">                
                <div class="mt-4 fw-bold card-title">Ved læsning:</div>
                <div class="table-wrap-25vh">
                    <table class="table table-striped ">
                        @if(readFilters.length== 0) 
                        {
                            <thead class="thead-sticky">
                                <tr><th class="ms-2 no-data">Ingen felter at vise.</th></tr>
                            </thead>    
                        } 
                        @else 
                        { 
                            <thead class="thead-sticky">
                                <tr>
                                    <th class="header" scope="col"> #</th>
                                    <th class="header" scope="col"> Navn </th>
                                    <th class="header" scope="col"> Operator</th>
                                    <th class="header" scope="col"> Værdi </th>
                                    <th class="header" scope="col"> Linjeoperator </th>
                                    <th></th>
                                </tr>
                            </thead>    
                            <tbody>                                    
                                <!-- For Each Sync -->
                                @for (item of readFilters; track $index) 
                                {
                                    <tr>
                                        <td style="width: 60px;">{{ item.placement }}</td>
                                        <td>{{ getFieldname(item.dbTemplateItemId) }}</td>
                                        <td>{{ item.fieldOperator }}</td>
                                        <td>{{ item.fieldValue }}</td>    
                                        <td>{{  $index == ( readFilters.length - 1)  ? '' : item.statementOperator }} </td>  
                                        <td> <button class="text-danger" (click)="onRemoveFilter(item,'read')"
                                            title="Slet filter">
                                            Slet <i class="fa-solid fa-trash-can"></i>
                                        </button>
    </td>
                                    </tr>
                                }
                            </tbody>                            
                        }
                    </table>
                </div> 
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="mt-4 fw-bold card-title">Ved sletning:</div>
                <div class="table-wrap-25vh">
                    <table class="table table-striped ">
                        @if(deleteFilters.length== 0) 
                        {
                            <thead class="thead-sticky">
                                <tr><th class="ms-2 no-data">Ingen felter at vise.</th></tr>
                            </thead>    
                        } 
                        @else 
                        { 
                            <thead class="thead-sticky">
                                <tr>
                                    <th class="header" scope="col"> #</th>
                                    <th class="header" scope="col"> Navn </th>
                                    <th class="header" scope="col"> Operator</th>
                                    <th class="header" scope="col"> Værdi </th>
                                    <th class="header" scope="col"> Linjeoperator </th>
                                    <th></th>
                                </tr>
                            </thead>    
                            <tbody>                                    
                                <!-- For Each Sync -->
                                @for (item of deleteFilters; track $index) 
                                {
                                    <tr>
                                        <td style="width: 60px;">{{ item.placement }}</td>
                                        <td >{{ getFieldname(item.dbTemplateItemId) }}</td>
                                        <td >{{ item.fieldOperator }}</td>
                                        <td >{{ item.fieldValue }}</td>    
                                        <td>{{  $index == ( deleteFilters.length - 1)  ? '' : item.statementOperator }} </td>  
                                        <td> <button class="text-danger" (click)="onRemoveFilter(item,'delete')"
                                            title="Slet filter">
                                            Slet <i class="fa-solid fa-trash-can"></i>
                                        </button>

                                    </tr>
                                }
                            </tbody>                            
                        }
                    </table>
                </div> 
            </div>
        </div>

    </div>
    <div class="modal-footer bg-transparent">
        <button class="btn btn-success float-end" (click)="saveFiltre()" >Gem filtre</button>
    </div>
}
